import { useQuery } from '@tanstack/react-query';
import { getSwitchClientsList as getSwitchClientsListApi } from 'services/clients/apiSwitchClientList';
import { useAuth } from 'context/AuthContext';
import { useGetCurrentSessionUser } from 'hooks/useGetCurrentSessionUser';
import { useError } from 'context/ErrorContext';


export type currentSelectedClientType = {
  clientId: string;
  clientName: string;
  isClient: boolean;
  clientLogoUrl: string;
  needToShowClientLogo: boolean;
}

type SwitchClientListResponse = {
  clientId: string;
  clientLogoUrl: string;
  clientName: string;
  isClient: boolean;
  needToShowClientLogo: boolean;
}


export function useSwitchClientsList() {
  const { handleErrorAction } = useError();
  const sessionStorageValue = useGetCurrentSessionUser('currentSelectedClient') as currentSelectedClientType;

  const { user } = useAuth();
  let clientId = '';
  if (sessionStorageValue) {
    clientId = sessionStorageValue.clientId
  } else {
    clientId = user?.clientId
  }
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['switchClientList'],
    queryFn: async () => {
      const { data } = await getSwitchClientsListApi(clientId)
      return data as SwitchClientListResponse[];
    },
    enabled: !!clientId,
    onError: (error: Error) => {
      handleErrorAction(error)
    },
    cacheTime: 0,
    staleTime: 0
  })

  return { data: data ?? [], isLoading, isFetching }
}